




import Vue from 'vue'
import dayjs from 'dayjs';

export default Vue.extend({
  components: {
  },
  
  props:{
    label:{
      type: String,
      default: '',
    },
    chartData:{
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
        chart: undefined
    }
  },
  computed: {
  },
  mounted() {
    console.log('chart mounted');
    this.init();
  },
  created() {
  },
  beforeDestroy() {
    this.chart?.clear();
    this.chart?.dispose();
  },
  methods: {
    init() {
      const seriesData = []
      const legendData = []
      let seriesName = ''
      this.chartData.forEach(res =>{
        legendData.push(dayjs(res.time*1).format('mm:ss.SSS'))
        seriesData.push(res.value)
        seriesName = this.label
      })
      // 基于准备好的dom，初始化echarts实例
      this.chart = (this as any).$echarts.init(
        this.$refs.chart as any
      );
      // 指定图表的配置项和数据
      var option = {
        title:{
          show:false
        },
        tooltip: {
          trigger: 'axis',
          formatter: (val) =>{
            return this.toolTipHtml(val)
          },
        },
        legend: {
          show: false
        },
        dataZoom: [
          {
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              right: 80,
              left: 80
          }
        ],
        grid: {
          left: '30',
          right: '60',
          bottom: '60',
          top: '10',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {onZero: true},
          data: legendData
        },
        color: ['#37A2DA','#32C5E9','#67E0E3','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#E062AE','#E690D1','#e7bcf3','#9d96f5','#8378EA','#96BFFF'],
        yAxis: [
          {
            type: 'value',
            boundaryGap: true,
            axisLine: {
                show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel:{
              formatter: value =>{
                return this.addCompany('',value)
              }
            }
          }
        ],
        series: [
          {
            name: seriesName,
            type: 'line',
            smooth: true,
            data: seriesData
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
    addCompany(unit,value){
      return value!== undefined ? value + (unit ? unit : '') : '-'
    },
    toolTipHtml(value){
      let html = ''
      this.chartData.forEach(element => {
        if(dayjs(element.time*1).format('mm:ss.SSS') === value[0].name){
          html = `${element.name}: ${this.addCompany(' ',element.value)}<br />`
          html = html+`时间: ${dayjs(element.time*1).format('mm:ss.SSS')}`
        }
      });
      return html
    },
    showName(element){
      return this.label;
    }
  },
})
